export default {"src":"/_next/static/media/design-projects.5ba290c7.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};